const mutations = {
  getOurServices: (state, our_service) => {
    state.our_service = our_service;
  },
  getOurService: (state, our_service_id) => {
    state.our_service_id = our_service_id;
  },
  postOurService: (state, new_our_service) => {
    state.our_service.push(new_our_service);
  },
  putOurService: (state, payload) => {
    state.our_service = state.our_service.map((our_service) => {
      if (our_service.our_service_id === payload.id) {
        return Object.assign({}, our_service, payload.formData);
      }
      return our_service;
    });
  },
  delOurService(state, id) {
    const index = state.our_service.findIndex(our_service => our_service.our_service_id == id);
    state.our_service.splice(index, 1);
  },
};

export default mutations;
